import React from 'react';
import { FaLocationArrow, FaMapMarkerAlt, FaPhone } from 'react-icons/fa';

const ContactAddress = () => {
  return (
    <div className="address">
        <div className="add">
          <div className="icon">
            <FaMapMarkerAlt />
          </div>
          <p>Village- Dankanya, Post office- Nayeli <br />District-Nainital Uttarakhand</p>
        </div>
        <div className="add">
          <div className="icon">
            <FaPhone />
          </div>
          <p>Mr. Nityanand Lohani :- 8750774273 <br />Pooja Pandey :- 8630395406</p>
        </div>
        <div className="add">
          <div className="icon">
            <FaLocationArrow />
          </div>
          <p>Pujapandey86303@gmail.com</p>
        </div>
    </div>
  )
}

export default ContactAddress
